import React from 'react';
import clsx from 'clsx';
import { type FCC } from 'types';
import styles from './FormContainer.module.scss';

interface FormContainerProps {
  className?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  autoComplete?: string;
}

const FormContainer: FCC<FormContainerProps> = ({
  onSubmit,
  children,
  className,
  autoComplete,
}) => (
  <section className={clsx(styles.formContainer, className)}>
    <form autoComplete={autoComplete} id="form" onSubmit={onSubmit} noValidate>
      {children}
    </form>
  </section>
);

export default FormContainer;
